// @flow


const PermissionsListing = {

  //
  // Booking
  //

  booking: {
    book: {
      label: 'book',
      permissions: {
        canCreateBooking: { label: 'canCreateBooking' },
        canCreateBookingOverLimit: { label: 'canCreateBookingOverLimit' },
        canEditBooking: { label: 'canEditBooking' },
        canConfirmWaitingBooking: { label: 'canConfirmWaitingBooking' },
        canCancelBooking: { label: 'canCancelBooking' },
        canFinalizeBooking: { label: 'canFinalizeBooking' },
        canMarkBookingAsSeen: { label: 'canMarkBookingAsSeen' },
        canEditPeriodStateForDay: { label: 'canEditPeriodStateForDay' },
      }
    },
    settings: {
      label: 'settings',
      permissions: {
        canEditSettings: { label: 'canEditSettings' },
      }
    }
  },

  //
  // Pro account
  //

  proAccount: {
    self: {
      label: 'self',
      permissions: {
        canEditAccount: { label: 'canEditAccount' },
      }
    },
    role: {
      label: 'role',
      permissions: {
        canCreateRole: { label: 'canCreateRole' },
      }
    },
    domain: {
      label: 'domain',
      permissions: {
        canCreateDomain: { label: 'canCreateDomain' }
      }
    },
    restaurantsGroup: {
      label: 'restaurantsGroup',
      permissions: {
        canCreateRestaurantsGroup: { label: 'canCreateRestaurantsGroup' }
      }
    },
    restaurant: {
      label: 'restaurant',
      permissions: {
        canCreateRestaurant: { label: 'canCreateRestaurant' }
      }
    }

  },

  //
  // RestaurantMenu
  //

  restaurantMenu: {
    settings: {
      label: 'settings',
      permissions: {
        canEditSettings: { label: 'canEditSettings' },
      }
    }
  },

  //
  // Order
  //

  order: {
    settings: {
      label: 'settings',
      permissions: {
        canEditSettings: { label: 'canEditSettings' },
      }
    }
  },

  //
  // RestaurantSettings
  //

  restaurantSettings: {
    publicInfo: {
      label: 'publicInfo',
      permissions: {
        canEdit: { label: 'canEdit' },
      }
    },
    menu: {
      label: 'menu',
      permissions: {
        canEdit: { label: 'canEdit' },
      }
    },
    openingHours: {
      label: 'openingHours',
      permissions: {
        canEdit: { label: 'canEdit' },
      }
    },
    legal: {
      label: 'legal',
      permissions: {
        restaurateur: {
          label: 'restaurateur',
          permissions: {
            canEdit: { label: 'canEdit' },
          }
        },
        society: {
          label: 'society',
          permissions: {
            canEdit: { label: 'canEdit' },
          }
        },
        representative: {
          label: 'representative',
          permissions: {
            canEdit: { label: 'canEdit' },
          }
        }
      }
    },
    finance: {
      label: 'finance',
      permissions: {
        bankAccount: {
          label: 'bankAccount',
          permissions: {
            canEdit: { label: 'canEdit' },
            canCreate: { label: 'canCreate' }
          }
        },
        other: {
          label: 'other',
          permissions: {
            canEdit: { label: 'canEdit' },
          }
        }
      }
    },
    features: {
      label: 'features',
      permissions: {
        canEdit: { label: 'canEdit' },
      }
    },
    configuration: {
      label: 'configuration',
      permissions: {
        general: {
          label: 'general',
          permissions: {
            canEdit: { label: 'canEdit' },
          }
        },
        pos: {
          label: 'pos',
          permissions: {
            canEdit: { label: 'canEdit' },
          }
        },
        mangoPay: {
          label: 'mangoPay',
          permissions: {
            canEdit: { label: 'canEdit' },
          }
        },
        commission: {
          label: 'commission',
          permissions: {
            canEdit: { label: 'canEdit' },
          }
        }
      }
    },
    theme: {
      label: 'theme',
      permissions: {
        canEdit: { label: 'canEdit' },
      }
    }
  }
};

export default PermissionsListing;



// WEBPACK FOOTER //
// ./scripts/utils/permissions/PermissionsListing.js